import { get, values } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getPosSearchItems = get('POS.searchItems');

export const getPosSearchItemsByUniqId = createSelector(
  getPosSearchItems,
  get('byUniqId')
);

export const getPosSearchItemsList = createSelector(
  getPosSearchItemsByUniqId,
  values
);

export const getIsFetching = createSelector(getPosSearchItems, get('fetching'));
export const getIsFetched = createSelector(getPosSearchItems, get('fetched'));
export const getFetchingError = createSelector(
  getPosSearchItems,
  get('fetchingError')
);
